import {Component, OnInit} from '@angular/core';
import {SectionBase} from '../../../components/section/section-base';
import {FieldType} from '../../../models/field-type';
import {InsuranceCompanyCode} from '../../../models/insurance-company-code.enum';
import {OfferModificationsService} from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {ApplicationStateService} from '../../../services/application-state.service';

@Component({
  selector: 'app-uniqa-discount-code-section',
  templateUrl: './uniqa-discount-code-section.component.html',
  styleUrls: ['./uniqa-discount-code-section.component.scss']
})
export class UniqaDiscountCodeSectionComponent extends SectionBase implements OnInit {

  get sectionVisible(): boolean {
    return this.offerModificationsService.callCenterMode && (this.stateService.insuranceCompanyCode === InsuranceCompanyCode.UNIQA || this.stateService.insuranceCompanyCode === InsuranceCompanyCode.AXA_DIRECT);
  }

  get fieldKey(): string {
    return this.stateService.insuranceCompanyCode;
  }

  get caption(): string {
    if (this.stateService.insuranceCompanyCode === InsuranceCompanyCode.UNIQA) {
      return 'UNIQA_DISCOUNT_CODE_SECTION.uniqaDiscountCode'
    }
    if (this.stateService.insuranceCompanyCode === InsuranceCompanyCode.AXA_DIRECT) {
      return 'UNIQA_DISCOUNT_CODE_SECTION.axaDiscountCode'
    }
  }

  constructor(private offerModificationsService: OfferModificationsService,
              private stateService: ApplicationStateService) {
    super();
  }

  ngOnInit() {
    this.createConfig();
    this.buildForm();
    this.initControlsChanges();
  }

  createConfig(): void {
    this.formConfig = {
      formKey: 'UNIQA_DISCOUNT_CODE_SECTION',
      fieldsConfig: [{
        fieldKey: this.fieldKey,
        caption: this.caption,
        type: FieldType.TextField,
        properties: {
          textTransform: {
            type: 'uppercase'
          },
        }
      }]
    }
  }

  initBean(): void {
  }

  initControlsChanges(): void {
    this.getControl(this.fieldKey).valueChanges.subscribe(value => {
      this.offerModificationsService.discountCode = value;
      this.offerModificationsService.saveModificationInCache();
    });
  }

}
